// "New version available · Reload": an open tab keeps running the bundle it loaded, so after a
// deploy it checks /version.json (on focus, and every minute) against the build it was built as.
// Terminal sessions live on the machine, so a reload is safe.

import { useEffect, useState } from 'react';

const CHECK_EVERY = 60_000;

async function liveBuild(): Promise<string | null> {
  try {
    const r = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) return null; // dev server: no version.json
    return ((await r.json()) as { build?: string }).build ?? null;
  } catch {
    return null;
  }
}

export function UpdateNotice() {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (stale) return;
    let alive = true;
    const check = async () => {
      if (document.hidden) return;
      const live = await liveBuild();
      if (alive && live && live !== __CMX_BUILD__) setStale(true);
    };
    const t = setInterval(check, CHECK_EVERY);
    const onFocus = () => void check();
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onFocus);
    void check();
    return () => {
      alive = false;
      clearInterval(t);
      window.removeEventListener('focus', onFocus);
      document.removeEventListener('visibilitychange', onFocus);
    };
  }, [stale]);
  if (!stale) return null;
  return (
    <div className="update-notice" role="status" data-testid="update-notice">
      <span className="update-dot" aria-hidden="true" />
      <span>New version of cmx available</span>
      <button className="btn btn-xs btn-primary" onClick={() => location.reload()} data-testid="update-reload">
        Reload
      </button>
    </div>
  );
}
